import {
	Instance, types,
} from 'mobx-state-tree';

const Step = types
	.model('Step', {
		id: types.identifierNumber,
		title: types.optional(types.string, ''),
		is_done: types.number,
	})
	.volatile(() => ({
		loading: false,
	}))
	.views(() => ({}));

export default Step;

export interface IStepModel extends Instance<typeof Step> {}
